module.exports = __webpack_public_path__ + "static/media/regal-rush-vertical-white-bg-gold-300x300-1.6ab7f062.png";